export default "__VITE_ASSET__C7hU_Pp8__"